import { SET_RIGHTPANEL_CONTENT, RightPanelContentAction } from './types';
import { RightPanelContent } from '../../constants/rightpanelContent';

export function setRightPanelContent(component: RightPanelContent): RightPanelContentAction {
    return {
        type: SET_RIGHTPANEL_CONTENT,
        component,
    };
}
